/**
 * Shared tab scroll visibility logic. Used by settings and tab-view components.
 */
export function getTabScrollVisibility(menu: HTMLElement): { showLeftScroll: boolean; showRightScroll: boolean } {
  return {
    showLeftScroll: menu.scrollLeft > 0,
    showRightScroll: menu.scrollWidth > menu.clientWidth + menu.scrollLeft
  };
}
